import { createFileRoute, notFound } from '@tanstack/react-router'

import { BoardNotFoundState, BoardPage, isBoardBranchNotFound } from '@/pages/board-page'

export const Route = createFileRoute('/branch/$id')({
    params: {
        parse: ({ id }) => {
            if (!/^\d+$/.test(id)) return false

            return { id: Number(id) }
        },
    },
    loader: async ({ params }) => {
        const isNotFound = await isBoardBranchNotFound(params.id).catch(() => false)

        if (isNotFound) throw notFound()
    },
    component: RouteComponent,
    notFoundComponent: () => <BoardNotFoundState variant='branch-not-found' />,
    onEnter: () => {
        document.title = 'Катит | Доска очереди'
    },
})

function RouteComponent() {
    const { id } = Route.useParams()

    return <BoardPage key={id} branchId={id} />
}
